<template>
  <full-container v-loading="loading">
    <!--工具条-->
    <div slot="header" class="toolbar">
      <div class="toolbar">
        <ul class="tabs">
          <li
            v-for="(item, index) in tenantOptions"
            :key="index"
            :class="{ selected: queryParams.tenant == item.value }"
            @click="
              queryParams.tenant = item.value
              onSearch()
            "
          >
            {{ item.text }}
          </li>
        </ul>
        <el-switch v-model="queryParams.hasQuantity" active-text="只看有库存的商品" @change="onSearch" />
      </div>
      <el-form ref="ff" size="small" :inline="true" :model="queryParams" class="search-form">
        <el-form-item>
          <el-input v-model="queryParams.code" clearable placeholder="编码" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="queryParams.keyWord" clearable placeholder="品名/规格" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--表格-->
    <el-table ref="tb" :data="datalist.Items" height="100%">
      <el-table-column label="货仓" min-width="120" show-overflow-tooltip>
        <span slot-scope="{ row }">{{ row.TenantName }}{{ row.Warehouse }}</span>
      </el-table-column>
      <el-table-column prop="Code" label="编码" min-width="100" />
      <el-table-column prop="Name" label="品名" min-width="150" />
      <el-table-column prop="Spec" label="规格" min-width="200" show-overflow-tooltip />
      <el-table-column prop="Unit" label="主计量" min-width="60" align="center" />
      <el-table-column label="可用数量" min-width="100" align="center">
        <template slot-scope="{ row }">
          <el-tooltip v-if="row.Quantities" placement="right">
            <div slot="content" style="line-height: 2">
              <p>结存数量：{{ row.Quantities.Quantity1 }}{{ row.Unit }}</p>
              <p>结存件数：{{ row.Quantities.Quantity2 }}{{ row.Unit }}</p>
              <p>可用数量：{{ row.Quantities.Quantity3 }}{{ row.Unit }}</p>
              <p>可用件数：{{ row.Quantities.Quantity4 }}{{ row.Unit }}</p>
              <p>待发货数：{{ row.Quantities.Quantity5 }}{{ row.Unit }}</p>
            </div>
            <el-link type="primary">{{ row.Quantities.Quantity3 }}{{ row.Unit }}</el-link>
          </el-tooltip>
          <template v-else>{{ row.Quantity }}</template>
        </template>
      </el-table-column>
      <slot name="column" />
    </el-table>

    <!--分页-->
    <div slot="footer" class="toolbar">
      <slot name="operate" />
      <el-pagination background :page-size="datalist.PageSize" :current-page="datalist.PageIndex" :total="datalist.TotalCount" @current-change="onPager" />
      <slot name="operate-r" />
    </div>
  </full-container>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      tenantOptions: [{ text: '全部' }, { text: '莱尔', value: 1 }, { text: '威能达', value: 2 }],
      datalist: {},
      queryParams: {
        index: 1,
        size: 30,
        ...this.$route.params
      },
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    onDrawer () {
      alert(1)
    },
    // 查询参数
    onSearch () {
      this.queryParams.index = 1
      this.loadData()
    },
    // 分页触发事件
    onPager (val) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.$apis.product.stock.list({
        ...this.queryParams,
        hasQuantity: !this.queryParams.hasQuantity ? null : true
      }).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
ul.tabs {
  display: flex;
  padding: 0 16px;
  li {
    list-style: none;
    padding: 5px 0;
    position: relative;
    cursor: pointer;
  }
  li + li {
    margin-left: 20px;
  }
  li.selected {
    color: #409eff;
  }
  li.selected::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 3px;
    width: 100%;
    background: #409eff;
  }
}
</style>